<template>
  <div class="customer-edit-customer-property" v-bind:class="{loaded}">
    <template v-if="loaded">
      <template v-if="hasProperty">
        <a-row v-bind:gutter="15">
          <a-col v-bind:span="8">
            <label class="address-label">Postcode</label>
            <p>{{ property.postal_code || '' }}</p>
          </a-col>
          <a-col v-bind:span="8">
            <label class="address-label">Huisnummer</label>
            <p>{{ property.number || '' }}</p>
          </a-col>
          <a-col v-bind:span="4">
            <label class="address-label">Huisletter</label>
            <p>{{ property.number_letter || '' }}</p>
          </a-col>
          <a-col v-bind:span="4">
            <label class="address-label">Toevoeging</label>
            <p>{{ property.number_addition || '' }}</p>
          </a-col>
        </a-row>
        <a-row v-bind:gutter="15">
          <a-col v-bind:span="8">
            <label class="address-label">Straat</label>
            <p>{{ property.street || '' }}</p>
          </a-col>
          <a-col v-bind:span="8">
            <label class="address-label">Stad</label>
            <p>{{ property.city || '' }}</p>
          </a-col>
          <a-col v-bind:span="8">
            <label class="address-label">Land</label>
            <p>{{ property.country_name || '' }}</p>
          </a-col>
        </a-row>

        <CustomerPropertyEditComponent v-if="currentLivingConditionLoaded" v-bind:key="CustomerPropertyEditComponentKey"
                                       v-bind:auto-save="true"
                                       v-bind:current-living-condition="currentLivingCondition"
                                       v-bind:customer-property="customerProperty"
                                       v-bind:detailed="detailed"
                                       v-bind:disabled="hasChanges"
                                       v-bind:prefill-registration-date="false"
                                       v-bind:with-address-type=false
                                       v-on:save="onCustomerPropertySave"/>
        <template v-else>
          <a-row v-bind:gutter="15">
            <a-col v-bind:span="12">
              <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                        width="50%"></Skeleton>
              <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
              <template v-if="detailed">
                <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                          width="50%"></Skeleton>
                <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
                <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                          width="50%"></Skeleton>
                <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"
                          width="50%"></Skeleton>
              </template>
            </a-col>
            <a-col v-bind:span="12">
              <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                        width="50%"></Skeleton>
              <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
              <template v-if="detailed">
                <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                          width="50%"></Skeleton>
                <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"></Skeleton>
                <Skeleton height="22px" style="display: block;margin-bottom: 10px;" v-bind:loading="true"
                          width="50%"></Skeleton>
                <Skeleton height="32px" style="display: block;margin-bottom: 15px;" v-bind:loading="true"
                          width="50%"></Skeleton>
              </template>
            </a-col>
          </a-row>
        </template>

        <div class="pull-right">
          <a-tooltip v-if="customer.has_partner" placement="topLeft">
            <template slot="title">
              <span>Kopiëer adres naar partner</span>
            </template>
            <a-button type="primary"
                      v-bind:disable="!copyToPartnerButtonEnabled"
                      v-bind:loading="copyToPartnerButtonLoading"
                      v-on:click="handleCopyCustomerPropertyToPartner">
              Kopiëer naar partner
            </a-button>
          </a-tooltip>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>Koppel een ander adres</span>
            </template>
            <a-button type="primary" @click="handleShowCustomerPropertyCreate">
              Wijzig adres
            </a-button>
          </a-tooltip>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>Ontkoppel dit adres</span>
            </template>
            <a-button type="danger" v-on:click="handleDeleteClick">
              Verwijder adres
            </a-button>
          </a-tooltip>
        </div>
      </template>
      <a-button v-else class="create-button" type="primary" v-on:click="handleShowCustomerPropertyCreate">
        Adres toevoegen
      </a-button>
    </template>

    <a-modal v-model="createModalVisible"
             v-bind:title="searchAddressTitle"
             width="700"
             @cancel="handleCancelCreateCustomerProperty" @ok="handleCreateCustomerProperty">
      <h4>Klantadressen</h4>
      <div v-if="customerAssociatedProperties">
        <a-select style="width: 100%" @change="onCustomerAssociatedPropertySelected">
          <a-select-option v-for="(option, key) in customerAssociatedProperties" :key="key">
            {{ option.formatted_address }}
          </a-select-option>
        </a-select>
      </div>
      <div v-else>Er zijn nog geen adressen aan deze klant gekoppeld</div>
      <h4 style="margin-top: 2rem">Adres zoeken</h4>
      <PropertySearchOrCreateByAddressComponent
                                                style="margin-bottom: 15px"
                                                v-on:property-selected="onPropertySelected"/>
      <div v-if="hasSelectedProperty">
        <p><b>Geselecteerde pand</b></p>
        {{ selectedProperty.description }}
      </div>
    </a-modal>

    <a-modal v-model="confirmModalVisible" v-bind:title="searchAddressTitle"
             width="700"
             @cancel="handleConfirmCancelCreateCustomerProperty" @ok="handleConfirmCreateCustomerProperty">
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Gegevens kopiëren naar nieuw adres">
            <a-radio-group
                v-model="copyDataToNewAddress"
                button-style="solid">
              <a-radio-button v-bind:value="true">
                Ja
              </a-radio-button>
              <a-radio-button v-bind:value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import CustomerPropertyEditComponent from '~/modules/customer_property/components/EditComponent';
import PropertySearchByAddressComponent from '~/modules/property/components/SearchByAddressComponent';
import customerApi from "~/api/customer";
import propertyApi from "~/api/property";
import customerPropertyApi from "~/api/customer_property";
import customerCurrentLivingConditionApi from "~/api/customer_current_living_condition";
import {Skeleton} from 'vue-loading-skeleton';
import {CustomerPropertyAddressTypeEnum} from "../../../enums";
import ManualCreateComponent from "~/modules/property/components/ManualCreateComponent";
import PropertySearchOrCreateByAddressComponent from "../../property/components/SearchOrCreateByAddressComponent";
import moment from 'moment'

export default {
  name: "CustomerEditCustomerProperty",
  components: {
    PropertySearchOrCreateByAddressComponent,
    CustomerPropertyEditComponent,
    PropertySearchByAddressComponent,
    Skeleton,
    ManualCreateComponent
  },
  props: {
    customerId: {
      required: false,
      default: null
    },
    customerProp: {
      type: Object,
      required: false,
      default: null
    },
    addressType: {
      type: String,
      required: true
    },
    injectedProperty: {
      type: Object,
      required: false,
      default: null
    },
    detailed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      copyToPartnerButtonLoading: false,
      countries: [],
      customer: null,
      customerProperty: null,
      currentLivingCondition: null,
      currentLivingConditionLoaded: false,
      activeKey: [],
      createModalVisible: false,
      confirmModalVisible: false,
      copyDataToNewAddress: false,
      selectedProperty: null,
      postalCode: null,
      number: null,
      numberAddition: null,
      searchAddressTitle: 'Adres selecteren',
      useInjectedProperty: true,
      CustomerPropertyEditComponentKey: 0,
      customerAssociatedProperties: null
    };
  },
  mounted() {
    if (this.customerProp === null && this.customerId === null) {
      throw new Error('Either the customer object or customer id is required.');
    }

    this.initCustomer()
        .then(() => {
          if (this.customer.has_partner !== false) {
            this.initPartner().catch();
          }
          this.initCustomerProperty()
              .then(() => {
                if (
                    typeof this.customerProperty !== "undefined"
                    && this.customerProperty !== null
                    && typeof this.customerProperty.customer_current_living_condition === "undefined"
                ) {
                  this.initCustomerCurrentLivingCondition();
                  this.initCustomerAssociatedProperties()
                }
              }).finally(() => {
            this.loaded = true;
          })
        })
  },
  computed: {
    hasChanges() {
      if (this.hasProperty && typeof this.customerProperty.property !== "undefined" && typeof this.customerProperty.property.data !== "undefined") {
        return !(
            this.caseInsensitiveStringCompare(this.postalCode, this.property.postal_code)
            && this.caseInsensitiveStringCompare(this.number, this.property.number)
            && this.caseInsensitiveStringCompare(this.numberAddition, this.property.number_addition)
        );
      }
    },
    partner() {
      return this.customer.partner !== null;
    },
    copyToPartnerButtonEnabled() {
      return this.partner !== null;
    },
    hasSelectedProperty() {
      return this.selectedProperty !== null;
    },
    hasCurrentLivingCondition() {
      return this.currentLivingCondition !== null;
    },
    hasProperty() {
      return typeof this.customerProperty !== "undefined" && this.customerProperty !== null;
    },
    property() {
      // TODO: refactor
      if (this.injectedProperty && this.useInjectedProperty) {
        this.initCustomerProperty();
      }

      if (this.hasProperty
          && typeof this.customerProperty.property !== "undefined"
          && this.customerProperty.property !== null
          && typeof this.customerProperty.property.data !== "undefined"
          && this.customerProperty.property.data !== null) {
        return this.customerProperty.property.data;
      }
      return {};
    },
  },
  methods: {
    initCustomer() {
      return new Promise((resolve, reject) => {
        if (this.customerProp === null) {
          customerApi.find(this.customerId, ['partner']).then(response => {
            this.customer = response.data;
            resolve(this.customer);
          }).catch(reject);
        } else {
          this.customer = this.customerProp;
          resolve(this.customer);
        }
      });
    },
    initPartner() {
      return new Promise((resolve, reject) => {
        if (typeof this.customer.partner === "undefined" || this.customer.partner === null) {
          return customerApi.findPartnerByCustomerId(this.customer.id)
              .then(response => {
                this.customer.partner = response.data;
                resolve(this.customer.partner.data);
              })
              .catch(reject);
        } else {
          resolve(this.customer.partner.data);
        }
      });
    },
    initCustomerProperty() {
      return new Promise((resolve, reject) => {
        return customerPropertyApi.findCurrentByCustomerAndAddressType(this.customer.id, this.addressType, ['property', 'property.valuations']).then(response => {
          this.useInjectedProperty = false;
          this.customerProperty = response.data;
          this.postalCode = this.property.postal_code;
          this.number = this.property.number;
          this.numberAddition = this.property.number_addition;
          resolve(this.customerProperty);
          this.rerenderCustomerPropertyEditComponent()
        }).catch(error => {
          if (typeof error.response !== "undefined") {
            let errorResponse = error.response.data;
            if (
                typeof errorResponse.error !== "undefined"
                && typeof errorResponse.error.code !== "undefined"
                && errorResponse.error.code === 404
            ) {
              resolve();
            }
          } else {
            reject(error);
          }
        });
      });
    },
    initCustomerCurrentLivingCondition() {
      if (this.addressType === CustomerPropertyAddressTypeEnum.VISIT) {
        return customerCurrentLivingConditionApi.findOrCreateByCustomerAndProperty(this.customer.id, this.customerProperty.property_id)
            .then(response => {
              this.currentLivingCondition = response.data;
              this.currentLivingConditionLoaded = true;
            });
      } else {
        this.currentLivingConditionLoaded = true;

        return Promise.resolve();
      }
    },
    initCustomerAssociatedProperties() {
      propertyApi.getPropertiesAssociatedWithCustomer(this.customer.id).then(response => {
        this.customerAssociatedProperties = response.data
      })
      return Promise.resolve();
    },
    handleDeleteClick() {
      this.$confirm({
        title: 'Adres ontkoppelen',
        content: 'Weet je zeker dat je dit adres wilt ontkoppelen van deze klant?',
        okText: 'Ja',
        cancelText: 'Annuleren',
        onOk: () => {
          customerPropertyApi.delete(this.customerProperty.id).then(response => {
            this.customerProperty = null;
            this.$emit('customer-property-deleted')
          });
        },
        onCancel() {
        },
      });
    },
    handleShowCustomerPropertyCreate() {
      this.selectedProperty = null;
      this.createModalVisible = true;
    },
    onPropertySelected(property) {
      this.selectedProperty = property;
    },
    handleCreateCustomerProperty() {
      return new Promise((resolve, reject) => {
        if (this.hasSelectedProperty) {
          this.updateCurrentCustomerProperty(this.selectedProperty).then(resolve).catch(reject);
          // this.$emit('customer-property-updated', this.customerProperty)
        } else {
          this.$message.warning('Selecteer eerst een adres');
          reject();
        }
      });
    },
    updateCurrentCustomerProperty(selectedProperty) {
      return new Promise((resolve, reject) => {
        customerPropertyApi.createAsCurrent({
              customer_id: this.customer.id,
              property_id: selectedProperty.id,
              address_type: this.addressType,
              registration_date: moment().format(),
            }
        ).then((response) => {
          let customerProperty = response.data;
          this.$emit('customer-property-updated', response.data)
          // TODO: remove completely?
          // if (this.copyDataToNewAddress) {
          //   this.copyCustomerPropertyValuesToNew(this.customerProperty, customerProperty).then(() => {
          //     this.customerProperty = customerProperty;
          //   });
          // } else {
          //   this.customerProperty = customerProperty;
          // }

          this.createModalVisible = false;

          this.initCustomerProperty()
              .then(() => {
                if (
                    typeof this.customerProperty !== "undefined"
                    && this.customerProperty !== null
                    && typeof this.customerProperty.customer_current_living_condition === "undefined"
                ) {
                  this.initCustomerCurrentLivingCondition().then(resolve).catch(reject);
                } else {
                  resolve();
                }
              }).catch(reject);
        }).catch(error => {
          if (typeof error.response !== "undefined") {
            let errorResponse = error.response.data;
            if (errorResponse.error && errorResponse.error.errors) {
              for (let attribute in errorResponse.error.errors) {
                let errors = errorResponse.error.errors[attribute];
                errors.forEach(error => {
                  this.$notification['error']({
                    message: 'Er ging iets mis',
                    description: error,
                  });
                })
              }
            }
          }
          reject();
        });
      });
    },
    copyCustomerPropertyValuesToNew(oldCustomerProperty, newCustomerProperty) {
      newCustomerProperty.registration_date = oldCustomerProperty.registration_date;
      newCustomerProperty.municipality_registration_date = oldCustomerProperty.municipality_registration_date;
      newCustomerProperty.transaction_date = oldCustomerProperty.transaction_date;
      newCustomerProperty.owns_property = oldCustomerProperty.owns_property;
      newCustomerProperty.percentage_owner = oldCustomerProperty.percentage_owner;

      return customerPropertyApi.update(newCustomerProperty).then(() => {
        this.customerProperty = newCustomerProperty;
      }).catch(error => {
        if (typeof error.response !== "undefined") {
          let errorResponse = error.response.data;
          if (errorResponse.error && errorResponse.error.errors) {
            for (let attribute in errorResponse.error.errors) {
              let errors = errorResponse.error.errors[attribute];
              errors.forEach(error => {
                this.$notification['error']({
                  message: 'Er ging iets mis',
                  description: error,
                });
              })
            }
          }
        }
      });
    },
    handleCancelCreateCustomerProperty() {
      this.createModalVisible = false;
    },
    handleShowPropertySearchModal() {
      this.confirmModalVisible = true;
      this.searchAddressTitle = 'Adres wijzigen';
    },
    caseInsensitiveStringCompare(a, b) {
      if (typeof a !== "undefined" && typeof b !== "undefined") {
        a = (a ? a : '');
        b = (b ? b : '');
        return a.replace(/\s+/g, '').toLowerCase() === b.replace(/\s+/g, '').toLowerCase();
      }
    },
    onCountryChange() {
      this.$set(this.customerProperty, 'country', {
        data: this.countries.find(country => country.id === this.property.country_id)
      });
    },
    onCustomerPropertySave(customerProperty) {
      if (!customerProperty.is_current) {
        this.customerProperty = null;
      }
    },
    handleConfirmCreateCustomerProperty() {
      this.handleShowCustomerPropertyCreate();
      this.confirmModalVisible = false;
    },
    handleConfirmCancelCreateCustomerProperty() {
      this.confirmModalVisible = false;
      this.copyDataToNewAddress = null;
    },
    rerenderCustomerPropertyEditComponent() {
      this.CustomerPropertyEditComponentKey += 1;
    },
    handleCopyCustomerPropertyToPartner() {
      this.copyToPartnerButtonLoading = true;
      this.$emit('copy-to-partner', this.customerProperty)
    },
    onCustomerAssociatedPropertySelected(key) {
      this.selectedProperty = this.customerAssociatedProperties[key];
    }
  }
}
</script>
<style scoped>
.edit-customer-properties {
  position: relative;
  margin-bottom: 15px;
}

.create-button {
}

.address-label {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 500;
}
</style>
